export default __webpack_public_path__ + "static/char-v-46-ace9be9dd30aaa206008e55f2b17883d.png";